"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var createWatchable_1 = require("../../util/createWatchable");
var LocalStorage_service_1 = require("./LocalStorage.service");
var SessionStorage_service_1 = require("./SessionStorage.service");
/**
 * Used to cache items through local and session storage with expiration times
 */
var CacheService = /** @class */ (function () {
    function CacheService(localStorageService, sessionStorageService, storageKeyPrefix) {
        if (storageKeyPrefix === void 0) { storageKeyPrefix = 'cache-service-storage-'; }
        this.localStorageService = localStorageService;
        this.sessionStorageService = sessionStorageService;
        this.storageKeyPrefix = storageKeyPrefix;
        var localEntries = this.loadCachedDataFromStorageService(localStorageService);
        var sessionEntries = this.loadCachedDataFromStorageService(sessionStorageService);
        this.cacheMap = createWatchable_1.createWatchableMap(__spreadArray(__spreadArray([], __read(localEntries)), __read(sessionEntries)));
    }
    CacheService_1 = CacheService;
    CacheService.prototype.getAllKeys = function () {
        return Array.from(this.cacheMap.keys());
    };
    /**
     * Returns a new instance of the CacheService that uses the specified prefix in local and session storage
     * This returns an entirely new object every time it is called. It is up to the containing application to
     * properly reuse the instance that is created
     * @param cachePrefix
     */
    CacheService.prototype.useWithPrefix = function (cachePrefix) {
        if (!cachePrefix.endsWith('-')) {
            cachePrefix = cachePrefix + "-";
        }
        return new CacheService_1(this.localStorageService, this.sessionStorageService, cachePrefix);
    };
    /**
     * Adds an item to the cache storage in either session or local state
     * @param key
     * @param value
     * @param method
     * @param expirationInMinutes
     */
    CacheService.prototype.set = function (key, value, method, expirationInMinutes) {
        if (method === void 0) { method = 'session'; }
        if (expirationInMinutes === void 0) { expirationInMinutes = 15; }
        var expirationDate = new Date();
        expirationDate.setMinutes(expirationDate.getMinutes() + expirationInMinutes);
        var cacheItem = {
            expirationDate: expirationDate,
            value: value,
        };
        var storageService;
        switch (method) {
            case 'local':
                storageService = this.localStorageService;
                break;
            case 'session':
                storageService = this.sessionStorageService;
                break;
        }
        var transformedKey = this.convertToStorageKey(key);
        storageService.setItem(transformedKey, cacheItem);
        this.cacheMap.set(key, cacheItem);
    };
    /**
     * Adds a callback to be called when a key is set.
     * @param callback
     * @returns unsubscribeFunction
     */
    CacheService.prototype.onKeySet = function (callback) {
        return this.cacheMap.onSet(function (key, cacheItem) {
            callback(key, cacheItem.value);
        });
    };
    /**
     * Adds a callback to be called when a key is removed.
     * @param callback
     * @returns unsubscribeFunction
     */
    CacheService.prototype.onKeyDeleted = function (callback) {
        return this.cacheMap.onDelete(callback);
    };
    /**
     * Returns whether the specified key exists in the cache
     * @param key
     */
    CacheService.prototype.has = function (key) {
        return this.cacheMap.has(key);
    };
    CacheService.prototype.removeItem = function (key) {
        var storageKey = this.convertToStorageKey(key);
        this.sessionStorageService.removeItem(storageKey);
        this.localStorageService.removeItem(storageKey);
    };
    /**
     * Gets the cached item. Cache items contain expiration date and value. No need to use JSON.parse on value
     * @param key
     */
    CacheService.prototype.get = function (key) {
        var cacheItem = this.cacheMap.get(key);
        if (!cacheItem) {
            return null;
        }
        if (this.isCacheItemExpired(cacheItem)) {
            this.sessionStorageService.removeItem(this.convertToStorageKey(key));
            this.localStorageService.removeItem(this.convertToStorageKey(key));
            this.cacheMap.delete(key);
            return null;
        }
        return cacheItem;
    };
    /**
     * Clears all keys in local and session storage that were managed by the CacheService
     */
    CacheService.prototype.clear = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.getAllKeys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var storageKey = this.convertToStorageKey(key);
                this.sessionStorageService.removeItem(storageKey);
                this.localStorageService.removeItem(storageKey);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.cacheMap.clear();
    };
    /**
     * Adds a callback to be called when all items are cleared.
     * @param callback
     * @returns unsubscribeFunction
     */
    CacheService.prototype.onClear = function (callback) {
        return this.cacheMap.onClear(callback);
    };
    /**
     * Returns whether or not the ICacheItem is expired
     * @param cacheItem
     */
    CacheService.prototype.isCacheItemExpired = function (cacheItem) {
        var now = new Date();
        return now >= cacheItem.expirationDate;
    };
    CacheService.prototype.convertToStorageKey = function (key) {
        return "" + this.storageKeyPrefix + key;
    };
    CacheService.prototype.loadCachedDataFromStorageService = function (storageService) {
        var e_2, _a;
        var _this = this;
        var allKeys = storageService.getAllKeys(function (key) {
            return key.indexOf(_this.storageKeyPrefix) > 0;
        });
        var entries = [];
        try {
            for (var allKeys_1 = __values(allKeys), allKeys_1_1 = allKeys_1.next(); !allKeys_1_1.done; allKeys_1_1 = allKeys_1.next()) {
                var storageKey = allKeys_1_1.value;
                // Cody: I must have been drunk, this is definitely supposed to be storage service
                var itemAsStr = storageService.getItem(storageKey);
                if (!itemAsStr) {
                    break;
                }
                // Cache service requires it to be an object
                if (!itemAsStr.startsWith('{')) {
                    storageService.removeItem(storageKey);
                    break;
                }
                var cacheItem = JSON.parse(itemAsStr);
                // Convert from string to Date
                cacheItem.expirationDate = new Date(cacheItem.expirationDate);
                if (this.isCacheItemExpired(cacheItem)) {
                    storageService.removeItem(storageKey);
                    break;
                }
                var transformedKey = storageKey.substr(this.storageKeyPrefix.length);
                entries.push([transformedKey, cacheItem]);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (allKeys_1_1 && !allKeys_1_1.done && (_a = allKeys_1.return)) _a.call(allKeys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return entries;
    };
    var CacheService_1;
    CacheService = CacheService_1 = __decorate([
        CommonService_decorator_1.CommonService('CacheService'),
        __metadata("design:paramtypes", [LocalStorage_service_1.LocalStorageService,
            SessionStorage_service_1.SessionStorageService, Object])
    ], CacheService);
    return CacheService;
}());
exports.CacheService = CacheService;
//# sourceMappingURL=Cache.service.js.map